import { addMonths, format, parseISO } from 'date-fns'
import type { PaymentStatus, Sale, SaleInstallment } from '../types'

/** Valores das parcelas a prazo (array, JSON ou valor único legado). */
export const getDisplayInstallmentAmounts = (sale: Sale): number[] => {
  const count = Math.max(0, Number(sale.installment_count) || 0)
  const raw = sale.installment_amounts
  let amounts: number[] = []

  if (Array.isArray(raw)) {
    amounts = raw.map((x) => Number(x))
  } else if (typeof raw === 'string' && raw.trim()) {
    try {
      const parsed = JSON.parse(raw)
      if (Array.isArray(parsed)) amounts = parsed.map((x) => Number(x))
    } catch {
      amounts = []
    }
  }

  if (amounts.length === 0 && count > 0) {
    const single = Number(sale.installment_amount)
    if (Number.isFinite(single) && single > 0) {
      amounts = Array(count).fill(single)
    }
  }

  if (count > 0 && amounts.length < count) {
    const pad = amounts[amounts.length - 1] ?? 0
    while (amounts.length < count) amounts.push(pad)
  } else if (amounts.length > count) {
    amounts = amounts.slice(0, count)
  }

  return amounts
}

/** Parcelas estimadas quando a API ainda não persistiu cobranças individuais. */
export const buildPreviewSaleInstallments = (sale: Sale): SaleInstallment[] => {
  const amounts = getDisplayInstallmentAmounts(sale)
  const first = sale.next_installment_due_date
  if (!first || amounts.length === 0) return []

  const baseStr = first.split('T')[0]
  const base = parseISO(`${baseStr}T12:00:00`)

  return amounts.map((amount, i) => ({
    id: -(i + 1),
    sale_id: sale.id,
    sequence: i + 1,
    due_date: format(addMonths(base, i), 'yyyy-MM-dd'),
    amount,
    status: 'pending' as PaymentStatus,
    paid_at: null,
  }))
}

/** Resolve parcelas persistidas ou pré-visualização para relatórios. */
export const resolveSaleInstallments = (sale: Sale): SaleInstallment[] => {
  if (sale.installments?.length) {
    return [...sale.installments].sort((a, b) => a.sequence - b.sequence)
  }
  return buildPreviewSaleInstallments(sale)
}
